import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private baseUrl = `${baseUrl}Dashboard`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    });
    return { headers };
  }

  getSummary(): Observable<any> {
    console.log('%c[DashboardService] 📊 Fetching dashboard summary...', 'color: dodgerblue');
    return this.http.get(`${this.baseUrl}/summary`, this.headers).pipe(
      tap({
        next: (res) => console.log('%c[DashboardService] ✅ Summary loaded:', 'color: green', res),
        error: (err) => console.error('[DashboardService] ❌ Failed to fetch summary:', err)
      })
    );
  }
}
